module.exports = __webpack_public_path__ + "static/img/14000301.030e861f.png";